"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const __1 = require("..");
const utils_1 = require("../utils");
/**
 * We mostly use this event for declaring end of all events to help in sync
 * @param event
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = prevState;
    order.placedAt = event.timestamp;
    if (!order.createdAt) {
        order.createdAt = event.timestamp;
    }
    if (order.orderItems) {
        order.orderItems = (0, __1.mergeIdenticalOrderItems)(order.orderItems);
    }
    if (order.status === domain_1.OrderStatus.DRAFT) {
        (0, utils_1.updateOrderAndItemsStatus)(order, domain_1.OrderStatus.CREATED, domain_1.OrderItemStatus.CREATED);
    }
    if (event.prepareTime || event.deliveryTime) {
        order.dueAt = (0, __1.calculateDueAt)(order.requiredAt, event.prepareTime || 0, event.deliveryTime || 0, order.placedAt);
    }
    return order;
}
exports.default = default_1;
//# sourceMappingURL=orderPlaced.js.map